























































import { Component, Prop, mixins, namespace } from 'nuxt-property-decorator'
import { VPopover } from 'v-tooltip'
import { mdiInformationOutline } from '@mdi/js'
import { ICatalogFilterItem } from '~/assets/interfaces/catalog'
import '~/assets/scss/v-tooltip.scss'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentCatalogFilterRange: () =>
      import('~/components/catalog/filter/catalog-filter-range.vue'),
    ComponentCatalogFilterCheckbox: () =>
      import('~/components/catalog/filter/catalog-filter-checkbox.vue'),
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentCatalogFilterImage: () =>
      import('~/components/catalog/filter/catalog-filter-image.vue'),
    VPopover,
    ComponentCatalogFilterInfo: () =>
      import('~/components/catalog/filter/catalog-filter-info.vue'),
  },
})
export default class ComponentCatalogFilter extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) items!: ICatalogFilterItem[]

  @siteStore.Getter('getOptionsCatalogPageType')
  readonly getOptionsCatalogPageType!: string

  private icons = {
    mdiInformationOutline,
  }

  private changeHandler(key: string, typeParam: string, e: any) {
    let newE = ''
    if (typeParam === 'range') {
      newE = e.min + ':' + e.max
    }
    if (typeParam === 'checkbox' || typeParam === 'image') {
      newE = e.join(';')
    }
    const query = { ...this.$route.query }
    query[key] = newE
    if (query.page) {
      query.page = '1'
    }
    if (query.showMore) {
      query.showMore = '0'
    }
    this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
  }

  private mounted(): void {
    this.$emit('loaded')
  }
}
